import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import SelectAssetChemicalModal from '@views/assets/SelectAssetChemicalModal';
import SelectSiteListModal from '@views/assets/SelectSiteListModal';
import IwsUpload from '@comp/upload/IwsUpload';
import { queryUserTreeList } from '@api/api';
import moment from 'moment';
import pick from 'lodash.pick';
import { httpAction } from '@/api/manage';
export default {
  name: 'ReagentDilutionModal',
  components: {
    SelectSiteListModal: SelectSiteListModal,
    SelectAssetChemicalModal: SelectAssetChemicalModal,
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      unit: '',
      title: '标液稀释表单',
      tableName: 'om_reagent_dilution',
      selectedSite: [],
      siteIds: [],
      selectedAssetChemical: [],
      assetChemicalIds: [],
      certificateNo: '',
      batchNo: '',
      standard: '',
      chemicalTotal: 0,
      compareStatus: true,
      userTree: [],
      //人员信息,
      form_fields: ['assetId', 'userId', 'siteId', 'motherLiquor', 'meteredVolume', 'concentration', 'status', 'remark'],
      form_fields_time: ['dilutionTime', 'effectiveTime'],
      validatorRules: {
        assetId: {
          rules: [{
            required: true,
            message: '请输入产品ID!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入稀释人员!'
          }]
        },
        dilutionTime: {
          rules: [{
            required: true,
            message: '请输入稀释时间!'
          }]
        },
        effectiveTime: {
          rules: [{
            required: true,
            message: '请输入有效时间!'
          }]
        },
        motherLiquor: {
          rules: [{
            required: true,
            message: '请输入母液体积!'
          }]
        },
        meteredVolume: {
          rules: [{
            required: true,
            message: '请输入定容体积!'
          }]
        },
        concentration: {
          rules: [{
            required: true,
            message: '请输入稀释浓度!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.loadTreeList();
  },
  methods: {
    moment: moment,
    edit: function edit(record) {
      var _this = this;

      this.unit = '';
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.model.userId = this.$store.getters.userInfo.id;
      if (undefined == this.model.dilutionTime) this.model.dilutionTime = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');

      if (this.model.id != null) {
        this.assetChemicalIds = this.model.assetId;
        this.selectedAssetChemical = this.model.productName;
        this.siteIds = this.model.siteId;
        this.selectedSite = this.model.siteName;
        this.standard = this.model.standard;
        this.certificateNo = this.model.certificateNo;
        this.batchNo = this.model.batchNo;
      } else {
        this.assetChemicalIds = [];
        this.selectedAssetChemical = [];
        this.siteIds = [];
        this.selectedSite = [];
        this.standard = '';
        this.certificateNo = '';
        this.batchNo = '';
      }

      this.visible = true;
      this.compareStatus = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.dilutionTime = formData.dilutionTime ? formData.dilutionTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.effectiveTime = formData.effectiveTime ? formData.effectiveTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.siteId = that.siteIds && (that.siteIds == [] || that.siteIds.length == 0) ? '' : that.siteIds;
          formData.name = that.productIds && (that.siteIds == [] || that.siteIds.length == 0) ? '' : that.siteIds;
          formData.assetId = that.productIds && (that.assetChemicalIds == [] || that.assetChemicalIds.length == 0) ? '' : that.assetChemicalIds;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this3 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    },
    selectSite: function selectSite() {
      this.$refs.SiteListModal.add(this.selectedSite, this.siteIds);
    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      this.selectedSite = [];
      this.siteIds = [];

      for (var i = 0; i < siteList.length; i++) {
        this.selectedSite.push(siteList[i].name);
        this.siteIds = siteList[i].id;
      }
    },
    selectAssetChemical: function selectAssetChemical() {
      this.$refs.AssetChemicalModal.category = 23;
      this.$refs.AssetChemicalModal.disableSubmit = true;
      this.$refs.AssetChemicalModal.add(this.selectedAssetChemical, this.assetChemicalIds);
    },
    // 子modal回调
    choseAssetChemical: function choseAssetChemical(productList) {
      this.selectedAssetChemical = [];
      this.assetChemicalIds = [];
      this.chemicalTotal = 0;

      for (var i = 0; i < productList.length; i++) {
        this.selectedAssetChemical.push(productList[i].productName + '(' + productList[i].surplus + 'ml)');
        this.chemicalTotal = this.chemicalTotal + productList[i].surplus;
        this.assetChemicalIds = productList[i].id;
        this.certificateNo = productList[i].certificateNo;
        this.batchNo = productList[i].batchNo;
        this.standard = productList[i].standard + productList[i].refUnit_dictText;
        this.unit = productList[i].refUnit_dictText;
      }

      this.loadConfig(this.assetChemicalIds == [] || this.assetChemicalIds.length == 0 ? null : this.assetChemicalIds);
    },
    compare: function compare(motherLiquor) {
      if (this.chemicalTotal == 0 || this.chemicalTotal < motherLiquor) {
        this.compareStatus = false;
        this.$notification.error({
          message: '标准物质存量不足,请更换标准物质后重新输入母液体积!'
        });
      } else this.compareStatus = true;
    }
  }
};